"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Representing a client credential. */
var Credential = /** @class */ (function () {
    function Credential() {
        this.beforeSendingCallbacks = [];
    }
    /** Used to perform action on a request before sending it. */
    Credential.prototype.beforeSending = function (callback) {
        this.beforeSendingCallbacks.push(callback);
        return this;
    };
    /** Processing configured before sending callbacks. */
    Credential.prototype.fireBeforeSendingCallbacks = function (request) {
        this.beforeSendingCallbacks.forEach(function (callback) { return callback(request); });
    };
    return Credential;
}());
exports.default = Credential;
